module.exports = __webpack_public_path__ + "assets/img/title.49f539f6.png";